import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import personFill from '@iconify/icons-eva/person-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { alpha, createTheme } from '@mui/material/styles';
import { Button, Card,Stack,Box, Divider, MenuItem, Typography, Avatar, IconButton } from '@mui/material';


// components
import MenuPopover from '../../components/MenuPopover';
//
import {encryptStorage} from '../../CustomStorage';
import { API_ENDPOINTS,APP_CONSTANTS, SOUNDBOX_APP_CONSTANTS } from '../../URLConstants';
import { useAuth } from '../../components/customContextProviders/AuthContext';
import { MHidden } from '../../components/@material-extend';


 
// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: homeFill,
    linkTo: '/'
  },
  // {
  //   label: 'Profile',
  //   icon: personFill,
  //   linkTo: '/comingsoon'
  // },
  {
    label: 'Control Center',
    icon: settings2Fill,
    linkTo: '/dashboard/soundboxcontrolcenter'
  }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  //
  const {sessionUserData}=useAuth()
  const {logoutSession}=useAuth()


// const adminData=encryptStorage.getItem("puad");
// const adminData=parseJwt(encryptStorage.getItem(SOUNDBOX_APP_CONSTANTS.L_KEY_OF_COGNITO_TOKEN));



  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const onLogout = () => {
    signout();
  }

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,    
        sm: 768,  
        md: 1024, 
        lg: 1280, 
        xl: 390,  
      },
    },
  });

async function signout(){



  logoutSession()

    // encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
    // encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_DATA);
    // encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_IOT_CLIENT_ID);
    // encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN);
    // navigate('/login', { replace: true });

  // ApiCallerInstance({
  //   method: 'put',
  //   url: API_ENDPOINTS.ADMIN_SIGNOUT,
    
  // }).then(res => {
  //   encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
  //   encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_DATA);
  //   encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_IOT_CLIENT_ID);
  //   encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN);

  //   disConnectMqtt();

  //   navigate('/login', { replace: true });
  //  // window.location.reload();

  // }).catch(err => {
  //   console.log("failed",err);

  // });
}


  return (
    <>
    <Card sx={{radius:"10px", minWidth:{md:"190px", sm:"190px"}, p:.5}}  onClick={handleOpen}>
    <Stack direction="row"  spacing={1} alignItems="center" >

      <IconButton
        ref={anchorRef}
       
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <Avatar  alt="photoURL" />
      </IconButton>

      <MHidden width="smDown">
        <Box>
          <Typography sx={{ lineHeight: "17px", fontWeight: 600, fontSize: "14px" }}>
            {sessionUserData?.user?.name}
          </Typography>
          <Typography sx={{ lineHeight: "15px", fontWeight: 400, fontSize: "12px" }}>
            {sessionUserData?.user?.role}
          </Typography>
        </Box>
      </MHidden>


      </Stack>
      </Card>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {sessionUserData?.user?.name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {sessionUserData?.user?.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button onClick={onLogout} fullWidth color="inherit" variant="outlined">
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}